import { gamePresentationOf } from "@softmax/web-features/coworlds";
import { matchRoute } from "@softmax/web-addresses";

import { gameTheaterQueryKeys } from "../../game-types";
import { type GamePageContext } from "../../game-types";

import { type AdmissionDecision } from "./admission.types";

export function publicPresentationAdmission({
  url,
  game,
}: {
  url: URL;
  game: GamePageContext | null;
}): AdmissionDecision | null {
  const pathname = url.pathname.replace(/^\/unlisted(?=\/)/, "");
  const route = matchRoute(url.pathname);

  if (matchRoute(pathname).name === "retiredPaper")
    return { kind: "not-found" };

  if (game?.mode === "upload") return { kind: "allowed" };

  const isRoot = game !== null && pathname.split("/").length === 2;

  if (isRoot && url.searchParams.has("version")) return { kind: "allowed" };

  if (
    url.searchParams.get("view") === "lobby" &&
    ["watch", "game.home", "game.league"].includes(route.name)
  ) {
    return {
      kind: "navigate",
      navigation: { kind: "lobby" },
    };
  }

  if (isRoot && gameTheaterQueryKeys.some((key) => url.searchParams.has(key))) {
    return { kind: "allowed" };
  }

  const presentation = gamePresentationOf(game?.corpusSlug ?? "");

  if (isRoot && presentation.home === "desk")
    return { kind: "allowed", presentation: "desk" };

  if (isRoot && presentation.home === "store")
    return { kind: "allowed", presentation: "home" };

  if (["game.desk", "game.report"].includes(route.name))
    return { kind: "allowed" };

  return null;
}
